// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { applicationPromise } from "./application"

const application = await applicationPromise

import Agencies__Estimates__FormController from "./agencies/estimates/form_controller"
application.register("agencies--estimates--form", Agencies__Estimates__FormController)

import Agencies__Estimates__VariantController from "./agencies/estimates/variant_controller"
application.register("agencies--estimates--variant", Agencies__Estimates__VariantController)

import Analytics__TrackController from "./analytics/track_controller"
application.register("analytics--track", Analytics__TrackController)

import Chats__MessagesController from "./chats/messages_controller"
application.register("chats--messages", Chats__MessagesController)

import Chats__PopupController from "./chats/popup_controller"
application.register("chats--popup", Chats__PopupController)

import Components__ClipboardController from "./components/clipboard_controller"
application.register("components--clipboard", Components__ClipboardController)

import Components__ConfirmActionController from "./components/confirm_action_controller"
application.register("components--confirm-action", Components__ConfirmActionController)

import Components__DeleteAssetController from "./components/delete_asset_controller"
application.register("components--delete-asset", Components__DeleteAssetController)

import Components__DialogController from "./components/dialog_controller"
application.register("components--dialog", Components__DialogController)

import Components__IconPickerController from "./components/icon_picker_controller"
application.register("components--icon-picker", Components__IconPickerController)

import Components__IfcViewerController from "./components/ifc_viewer_controller"
application.register("components--ifc-viewer", Components__IfcViewerController)

import Components__NumericStepperController from "./components/numeric_stepper_controller"
application.register("components--numeric-stepper", Components__NumericStepperController)

import Components__PhotogalleryController from "./components/photogallery_controller"
application.register("components--photogallery", Components__PhotogalleryController)

import Components__PromptSubmitController from "./components/prompt_submit_controller"
application.register("components--prompt-submit", Components__PromptSubmitController)

import Components__SelectOnFocusController from "./components/select_on_focus_controller"
application.register("components--select-on-focus", Components__SelectOnFocusController)

import Contacts__FormController from "./contacts/form_controller"
application.register("contacts--form", Contacts__FormController)

import Contacts__IndexController from "./contacts/index_controller"
application.register("contacts--index", Contacts__IndexController)

import Draw__FormController from "./draw/form_controller"
application.register("draw--form", Draw__FormController)

import Events__FiltersController from "./events/filters_controller"
application.register("events--filters", Events__FiltersController)

import Events__FormController from "./events/form_controller"
application.register("events--form", Events__FormController)

import Events__VoiceRecorderController from "./events/voice_recorder_controller"
application.register("events--voice-recorder", Events__VoiceRecorderController)

import FinancialRecords__FiltersController from "./financial_records/filters_controller"
application.register("financial-records--filters", FinancialRecords__FiltersController)

import FinancialRecords__FormController from "./financial_records/form_controller"
application.register("financial-records--form", FinancialRecords__FormController)

import ImportSiteTasks__FormController from "./import_site_tasks/form_controller"
application.register("import-site-tasks--form", ImportSiteTasks__FormController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import Navigation__RemovalsController from "./navigation/removals_controller"
application.register("navigation--removals", Navigation__RemovalsController)

import Navigation__SidebarController from "./navigation/sidebar_controller"
application.register("navigation--sidebar", Navigation__SidebarController)

import PriceLists__FormCategoriesController from "./price_lists/form_categories_controller"
application.register("price-lists--form-categories", PriceLists__FormCategoriesController)

import PriceLists__SiteTasks__FormController from "./price_lists/site_tasks/form_controller"
application.register("price-lists--site-tasks--form", PriceLists__SiteTasks__FormController)

import PricingRequests__CalculatorController from "./pricing_requests/calculator_controller"
application.register("pricing-requests--calculator", PricingRequests__CalculatorController)

import Projects__FormController from "./projects/form_controller"
application.register("projects--form", Projects__FormController)

import Rooms__FormController from "./rooms/form_controller"
application.register("rooms--form", Rooms__FormController)

import SiteTaskMeasurements__FormController from "./site_task_measurements/form_controller"
application.register("site-task-measurements--form", SiteTaskMeasurements__FormController)

import SiteTaskMeasurements__IndexSingleController from "./site_task_measurements/index_single_controller"
application.register("site-task-measurements--index-single", SiteTaskMeasurements__IndexSingleController)

import SiteTaskMeasurements__OffcanvasController from "./site_task_measurements/offcanvas_controller"
application.register("site-task-measurements--offcanvas", SiteTaskMeasurements__OffcanvasController)

import SiteTasks__DefaultQtyController from "./site_tasks/default_qty_controller"
application.register("site-tasks--default-qty", SiteTasks__DefaultQtyController)

import SiteTasks__FillFromEstimateController from "./site_tasks/fill_from_estimate_controller"
application.register("site-tasks--fill-from-estimate", SiteTasks__FillFromEstimateController)

import SiteTasks__FormController from "./site_tasks/form_controller"
application.register("site-tasks--form", SiteTasks__FormController)

import SiteTasks__FormDetailsController from "./site_tasks/form_details_controller"
application.register("site-tasks--form-details", SiteTasks__FormDetailsController)

import SiteTasks__ReorderController from "./site_tasks/reorder_controller"
application.register("site-tasks--reorder", SiteTasks__ReorderController)

import Sites__CalendarController from "./sites/calendar_controller"
application.register("sites--calendar", Sites__CalendarController)

import Sites__DhtmlxGanttShowController from "./sites/dhtmlx_gantt_show_controller"
application.register("sites--dhtmlx-gantt-show", Sites__DhtmlxGanttShowController)

import Sites__Exports__FormController from "./sites/exports/form_controller"
application.register("sites--exports--form", Sites__Exports__FormController)

import Sites__SiteUpdatesController from "./sites/site_updates_controller"
application.register("sites--site-updates", Sites__SiteUpdatesController)

import Utils__ConfirmWithInputController from "./utils/confirm_with_input_controller"
application.register("utils--confirm-with-input", Utils__ConfirmWithInputController)

import Utils__ExpandDetailsController from "./utils/expand_details_controller"
application.register("utils--expand-details", Utils__ExpandDetailsController)

import Utils__Form__AutosaveController from "./utils/form/autosave_controller"
application.register("utils--form--autosave", Utils__Form__AutosaveController)

import Utils__Form__DatetimePickerController from "./utils/form/datetime_picker_controller"
application.register("utils--form--datetime-picker", Utils__Form__DatetimePickerController)

import Utils__Form__DynamicFieldsController from "./utils/form/dynamic_fields_controller"
application.register("utils--form--dynamic-fields", Utils__Form__DynamicFieldsController)

import Utils__Form__LeavePageController from "./utils/form/leave_page_controller"
application.register("utils--form--leave-page", Utils__Form__LeavePageController)

import Utils__GenerateCodeController from "./utils/generate_code_controller"
application.register("utils--generate-code", Utils__GenerateCodeController)

import Utils__HtmlEditorController from "./utils/html_editor_controller"
application.register("utils--html-editor", Utils__HtmlEditorController)

import Utils__MarkAsDestroyController from "./utils/mark_as_destroy_controller"
application.register("utils--mark-as-destroy", Utils__MarkAsDestroyController)

import Utils__MultiCheckboxesController from "./utils/multi_checkboxes_controller"
application.register("utils--multi-checkboxes", Utils__MultiCheckboxesController)

import Utils__PushNotificationsController from "./utils/push_notifications_controller"
application.register("utils--push-notifications", Utils__PushNotificationsController)

import Utils__SelectModalController from "./utils/select_modal_controller"
application.register("utils--select-modal", Utils__SelectModalController)

import Utils__SelectVatTaxController from "./utils/select_vat_tax_controller"
application.register("utils--select-vat-tax", Utils__SelectVatTaxController)

import Utils__ShowNoMoreController from "./utils/show_no_more_controller"
application.register("utils--show-no-more", Utils__ShowNoMoreController)

import Utils__StaleContentController from "./utils/stale_content_controller"
application.register("utils--stale-content", Utils__StaleContentController)

import Utils__UnauthorizedController from "./utils/unauthorized_controller"
application.register("utils--unauthorized", Utils__UnauthorizedController)
